import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { catchError, debounceTime, of, Subject, takeUntil } from 'rxjs';
import { Station, mapStatusToDisplay } from './station-configurator.interfaces';
import { EditStationDialogComponent } from '../dialogs/edit-station-dialog/edit-station-dialog.component';
import { StationService } from '../../services/station.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'app-station-configurator',
  templateUrl: './station-configurator.component.html',
  styleUrls: ['./station-configurator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StationConfiguratorComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['name', 'address', 'status', 'actions'];
  dataSource = new MatTableDataSource<Station>([]);

  pageSizeOptions = [10, 20, 50];
  pageSize = 10;
  pageIndex = 0;
  dataLength = 0;

  searchTerm = '';
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  loading = false;

  mapStatusToDisplay = mapStatusToDisplay;

  constructor(
    private dialog: MatDialog,
    private stationService: StationService,
    private snackbarService: SnackbarService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.searchSubject.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe(() => {
      this.pageIndex = 0;
      this.loadData();
    });

    this.loadData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  applyFilter(): void {
    this.searchSubject.next(this.searchTerm);
  }

  onPagination(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.cdr.markForCheck();

    const searchQuery = this.searchTerm.trim() || undefined;

    this.stationService
      .getStations$(this.pageSize, this.pageSize * this.pageIndex, searchQuery)
      .pipe(
        catchError(() => {
          this.snackbarService.error('Az állomások lekérése során hiba lépett fel!');
          this.loading = false;
          this.cdr.markForCheck();
          return of();
        }),
      )
      .subscribe((stationBatch) => {
        this.dataSource.data = stationBatch.items;
        this.dataLength = stationBatch.totalCount;
        this.loading = false;
        this.cdr.markForCheck();
      });
  }

  openEditDialog(station: Station): void {
    const dialogRef = this.dialog.open(EditStationDialogComponent, {
      data: { stationId: station.stationId },
      width: '1200px',
      maxWidth: '95vw',
      autoFocus: false,
      panelClass: 'white-dialog',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.loadData();
      }
    });
  }
}
